<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { messageDayLabel } from 'shared/helpers/timeHelper';

const props = defineProps({
  timestamp: {
    type: Number,
    required: true,
  },
});

const { t, locale } = useI18n();

const label = computed(() =>
  messageDayLabel(props.timestamp, {
    todayLabel: t('CONVERSATION.DATE_DIVIDER.TODAY'),
    yesterdayLabel: t('CONVERSATION.DATE_DIVIDER.YESTERDAY'),
    locale: locale.value,
  })
);
</script>

<template>
  <li class="flex justify-center items-center py-3 list-none">
    <!-- first-letter:uppercase because Intl returns lowercase weekday and month
         names in several locales (pt-BR gives "quarta-feira", "16 de agosto"). -->
    <span
      class="px-2.5 py-1 text-xs font-medium rounded-full bg-n-alpha-1 text-n-slate-11 first-letter:uppercase"
    >
      {{ label }}
    </span>
  </li>
</template>
